import { render, staticRenderFns } from "./memberMgt.vue?vue&type=template&id=0123b9c7&scoped=true&"
import script from "./memberMgt.vue?vue&type=script&lang=js&"
export * from "./memberMgt.vue?vue&type=script&lang=js&"
import style0 from "./memberMgt.vue?vue&type=style&index=0&id=0123b9c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123b9c7",
  null
  
)

component.options.__file = "memberMgt.vue"
export default component.exports